import moment from "moment";

export class FiscalYear {
    public values: number[] = [];
    public currentFiscalYear: number;

    constructor() {
        const today = moment();
        const currentYear = today.year();

        this.currentFiscalYear =
            today.month() >= 6
                ? currentYear + 1
                : currentYear;

        for (let year = this.currentFiscalYear - 2; year <= this.currentFiscalYear + 2; year++) {
            this.values.push(year);
        }

        this.values.sort((a, b) => b - a);
    }
}
